import { Injectable, Input } from '@angular/core';
import { AllChartsReqCommand } from '../models';
@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  setTablePreferences(
    tableName: string,
    value: any,
    pageSize: number,
    pageState?: { pageSize: number; pageNumber: number }
  ) {
    let tablePreferences = this.getTablePreferences();
    let preferenceValue = tablePreferences.find(
      (x: any) => x.tableName == tableName
    );
    if (preferenceValue) {
      preferenceValue.value = value || [];
      preferenceValue.pageSize = pageSize || 15;
      preferenceValue.pageState = pageState || { pageNumber: 1, pageSize: 15 };
    } else {
      tablePreferences.push({ tableName, value: value || [], pageSize: pageSize || 15, pageState : pageState || { pageNumber: 1, pageSize: 15 } });
    }
    localStorage.setItem('tablePreferences', JSON.stringify(tablePreferences));
  }

  getTablePreferences() {
    return JSON.parse(localStorage.getItem('tablePreferences') || '[]');
  }

  resetTablePreferences() {
    localStorage.removeItem('tablePreferences');
  }

  getTablePreferencesByTableName(tableName: string) {
    let tablePreferences = this.getTablePreferences();
    return tablePreferences.find((x: any) => x.tableName == tableName);
  }

  setSavedFilters(tableName: string, value: any) {
    let filters = this.getSavedFilters();
    let filterValue = filters.find((x: any) => x.tableName == tableName);
    if (
      filterValue &&
      filterValue.value &&
      filterValue.value.length &&
      filterValue.value.length > -1
    ) {
      let isExist = filterValue.value.find(
        (x: any) => x.name === value.filterValue.filterName
      );
      if (isExist) {
        isExist.filterValue = value.filterValue;
      } else {
        filterValue.value.push(value);
      }
    } else {
      filters.push({ tableName, value: [value] });
    }
    localStorage.setItem('savedFiltersDrawer', JSON.stringify(filters));
  }

  updateSavedFilters(tableName: string, value: any) {
    let filters = this.getSavedFilters();
    let filterValue = filters.find((x: any) => x.tableName === tableName);
    if (
      filterValue &&
      filterValue.value &&
      filterValue.value.length &&
      filterValue.value.length > -1
    ) {
      filterValue.value = filterValue.value.filter(
        (x: any) => x.name !== value.name
      );
      if (filterValue.value.length) {
        localStorage.setItem('savedFiltersDrawer', JSON.stringify(filters));
      } else {
        if (!filterValue.value.length) {
          filterValue = filterValue.value.filter(
            (x: any) => x.tableName !== tableName
          );
          filters = filters.filter((x: any) => x.tableName !== tableName);
          localStorage.setItem('savedFiltersDrawer', JSON.stringify(filters));
        }
      }
    }
  }

  getSavedFilters() {
    return JSON.parse(localStorage.getItem('savedFiltersDrawer') || '[]');
  }

  getSavedFiltersByTableName(tableName: string) {
    let filters = this.getSavedFilters();
    return filters.find((x: any) => x.tableName == tableName);
  }

  getLoggedInUser() {
    return JSON.parse(localStorage.getItem('loggedInUser') || '{}');
  }

  setPaitentsCurrentTab(tabName: string) {
    localStorage.setItem('PaitentsCurrentTab', tabName);
  }

  setARDetailCurrentTab(tabName: string) {
    localStorage.setItem('ARDetailCurrentTab', tabName);
  }

  getPaitentsCurrentTab() {
    const tabName = localStorage.getItem('PaitentsCurrentTab');
    return tabName;
  }

  getARDetailCurrentTab() {
    const tabName = localStorage.getItem('ARDetailCurrentTab');
    return tabName;
  }

  setARDetailTemplateCurrentTab(tabName: string) {
    localStorage.setItem('ARDetailTemplateCurrentTab', tabName);
  }

  getARDetailTemplateCurrentTab() {
    const tabName = localStorage.getItem('ARDetailTemplateCurrentTab');
    return tabName;
  }

  getGraphDate(): AllChartsReqCommand | null {
    const storedData = localStorage.getItem('graphData');
    if (storedData) {
      const graphData = JSON.parse(storedData);
      return graphData;
    }
    return null;
  }

  setGraphDate(graphDate: AllChartsReqCommand): void {
    localStorage.setItem('graphData', JSON.stringify(graphDate));
  }

  get graphFilters(): any {
    return this.getData('GraphFilters');
  }
  @Input() set graphFilters(value: any) {
    this.setData('GraphFilters', value);
  }

  get arAutomationCampaignsSnapshotFilter(): any {
    return this.getData('arAutomationCampaignsSnapshotFilter');
  }
  @Input() set arAutomationCampaignsSnapshotFilter(value: any) {
    this.setData('arAutomationCampaignsSnapshotFilter', value);
  }

  get overAllPaymentSnapshotFilter(): any {
    return this.getData('overAllPaymentSnapshotFilter');
  }
  @Input() set overAllPaymentSnapshotFilter(value: any) {
    this.setData('overAllPaymentSnapshotFilter', value);
  }

  get paymentPlanSnapshotFilter(): any {
    return this.getData('paymentPlanSnapshotFilter');
  }
  @Input() set paymentPlanSnapshotFilter(value: any) {
    this.setData('paymentPlanSnapshotFilter', value);
  }

  get paymentReportsFilter(): any {
    return this.getData('paymentReportsFilter');
  }
  @Input() set paymentReportsFilter(value: any) {
    this.setData('paymentReportsFilter', value);
  }

  getData(key: string) {
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  }
  removeData(key: string): void {
    localStorage.removeItem(key);
  }

  setData(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}
